import React from 'react';
import { Button } from '../../flayr-components/Button/Button';
import { Flex } from '../../flayr-components/Flex/Flex';
import CheckCircle from '../../lib/CheckCircle/CheckCircle';

interface ICheckAvailabilitySuccessProps {
  title?: string;
  subTitle?: string;
  className?: string;
  message?: string;
  ctaLabel?: string;
  onCtaClick?: (e?: any) => void;
}

const CheckAvailabilitySuccess: React.FC<React.PropsWithChildren<React.PropsWithChildren<ICheckAvailabilitySuccessProps>>> = ({
  title = 'Availability Check in Progress',
  subTitle = 'We will email and text you once the  provider responds',
  message = 'Most customers request 3 additional providers',
  ctaLabel = 'Request More Providers',
  className,
  onCtaClick,
}) => {
  return (
    <Flex column center className={className}>
      <CheckCircle className="block mb-3 text-5xl text-primary-1" />
      <div className="mb-4">{title}</div>
      <div className="mb-8 text-center text-gray-700">{subTitle}</div>
      <div className="mb-4 text-sm text-center text-gray-600">{message}</div>

      <Button color="primary" size="lg" onClick={onCtaClick} block>
        {ctaLabel}
      </Button>
    </Flex>
  );
};
export default CheckAvailabilitySuccess;
